module.exports = __webpack_public_path__ + "static/img/wpp3_1.5735275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp3_1.png
// module id = C/6N
// module chunks = 2